import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

export const fetchWorkRoles = async () => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/work-roles`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const geMyProjects = async () => {
  try {
    const token = getToken();
    const response = await axios.get(`${apiurl}/api/v1/user/projects`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getProjectTypes = async () => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/project-types`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getWorkLocations = async (cityquery) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/work-locations?city=${cityquery}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const createWork = async (data) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${apiurl}/api/v1/user/work-listing`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getAllWorks = async (page) => {
  try {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await axios.get(`${apiurl}/api/v1/work-listing?page=${page}`, {
      headers,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getWorkDetails = async (workId) => {
  try {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(
      `${apiurl}/api/v1/work-listing/${workId}`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getWorkDetailsForEdit = async (workId) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/work-listing/${workId}/edit`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const bookMarkWork = async (workId) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${apiurl}/api/v1/user/work-listing/${workId}/bookmark`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteWork = async (workId) => {
  try {
    const token = getToken();
    const response = await axios.delete(
      `${apiurl}/api/v1/user/work-listing/${workId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const reportWork = async (workId, data) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${apiurl}/api/v1/user/work-listing/${workId}/report`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const applyWork = async (workId, data) => {
  console.log("Applying to work ID:", workId, "with data:", data);
  try {
    const token = getToken();
    const response = await axios.post(
      `${apiurl}/api/v1/user/work-listing/${workId}/apply`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateWork = async (workId, data) => {
  try {
    const token = getToken();
    const response = await axios.put(
      `${apiurl}/api/v1/user/work-listing/${workId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getFilters = async () => {
  try {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(
      `${apiurl}/api/v1/work-listing/filter-list`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getAllWorksByQuery = async (queryString) => {
  console.log("Query String:", queryString);
  try {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await axios.get(`${apiurl}/api/v1/work-listing?${queryString}`, {
      headers,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const updateApplicantStatus = async (workId, applicant_id, data) => {
  try {
    const token = getToken();
    const response = await axios.put(
      `${apiurl}/api/v1/user/work-listing/${workId}/applicant/${applicant_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}


export const getRelatedWorks = async (workId) => {
  try {
    const token = getToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(
      `${apiurl}/api/v1/work-listing/${workId}/related-works`,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const createChatWithSelectedApplicants = async (workId, data) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${apiurl}/api/v1/user/work-listing/${workId}/chat`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


//downloadSubmissions
export const downloadSubmissions = async (workId, data) => {
  try {
    const token = getToken();
    const response = await axios.post(
      `${apiurl}/api/v1/user/work-listing/${workId}/document/pdf/download`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//make duplicate
export const makeDuplicate = async (workId) => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${apiurl}/api/v1/user/work-listing/${workId}/duplicate`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}


//https://api.autovertest.com/api/v1/work-listing/82/single-project
export const getSingleProject = async (projectId) => {
  try {
    const token = getToken();
    const response = await axios.get(
      `${apiurl}/api/v1/work-listing/project/${projectId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}
